import $ from 'jquery'

// (function(){
//     var eventTopics = $('.event-topics');
//     eventTopics.find('.topic').on('click', function(){
//         var topicElements = $(eventTopics.find('.topic'));
//         var isAlreadyActive = $(this)[0].classList.contains('active');
//         for(var x = 0; x < topicElements.length; x++){
//             topicElements[x].classList.remove('active');
//         }
//         if(!isAlreadyActive){
//             $(this)[0].classList.add('active');
//         }
//     })
// })()
document.addEventListener("DOMContentLoaded", function() { 
    handleTopics();
});



const handleTopics = function () {

    const $eventTopics = $('.event-topics');
    const topicElements = $eventTopics.find('.topic');

    topicElements.each(function (element) {
        if (topicElements[element].lastElementChild.innerText.trim().length === 0) {
            topicElements[element].classList.add('unclickable');
        }
    });
    
    $('.event-topics').find('.topic').on('click', function () {
        if ($(this).find('.details').text().trim().length === 0) {
            return;
        }

        if ($(this).hasClass('active')) {
            $(this).parent().find('.topic.active .details').slideToggle('fast');
            $(this).parent().find('.topic.active').removeClass('active');
            return;
        }

        $(this).parent().find('.topic.active .details').slideToggle('fast');
        $(this).parent().find('.topic.active').removeClass('active');

        $(this).addClass('active');
        
        $(this).find('.details').slideToggle('fast');
    })
}